export default __webpack_public_path__ + "static/media/history.1b81ca82.svg";